import { Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { ConfigureControl } from '.';
import { filterConfigurationApiHash } from '../../../../utils/configurationApi';
import TableFilter from '../configurationApiBlock/configurationApiTable/components/TableFilter';

const ConfigureControlWrapper = ({ hashBySource, hash, onHashChange, sport, sources }) => {
  const [filteredHashBySource, setFilteredHashBySource] = useState(hashBySource);

  const filterHashBySource = useCallback((filter) => {
    const newFilteredHashBySource = filterConfigurationApiHash(hashBySource, filter);
    for (let league of Object.values(newFilteredHashBySource)) {
      league.isCollapsed = !!filter;
    }
    setFilteredHashBySource(newFilteredHashBySource);
  }, [hashBySource]);

  const handleToggleCollapse = useCallback((key, value) => {
    const newFilteredHashBySource = { ...filteredHashBySource };
    newFilteredHashBySource[key].isCollapsed = value;
    setFilteredHashBySource(newFilteredHashBySource);
  }, [filteredHashBySource]);

  useEffect(() => {
    setFilteredHashBySource(hashBySource);
  }, [hashBySource]);

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <TableFilter delay={300} onChange={(value) => filterHashBySource(value)} />
      {Object.values(filteredHashBySource).map((item) => <ConfigureControl
        key={item.id}
        item={item}
        hash={hash}
        level={2}
        onHashChange={onHashChange}
        parentId={null}
        sport={sport}
        sources={sources}
        toggleCollaps={(value) => handleToggleCollapse(item.id, value)}
      />)}
    </Box>
  );
}

export default ConfigureControlWrapper;
